import React, { useEffect, useState ,useContext} from 'react'
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Accordion, AccordionDetails, AccordionSummary, Card, CardHeader, Grid } from '@mui/material';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import { useLocation } from 'react-router-dom';
import AppointmentsApi from '../../../Classes/API/Appointments/AppointmentsApi';
import SearchStringOrIntReq from '../../../Classes/Models/Requests/SearchStringOrIntReq';
import Swal from 'sweetalert2';
import MDButton from 'components/MDButton';
import DateTimePicker from 'react-date-picker'
import { ExpandMore } from '@mui/icons-material';
import './patient-programme-details-style.scss';
import { LanguageContext } from "App";
const index = () => {

  let { state } = useLocation();

  const [ResponseData, setResponseData] = useState({});
  const [IsLoaded, setIsLoaded] = useState(false);
  const [searchDate, SetSearchDate] = useState(new Date()) // doos tab for copilot
  const {translations} = useContext(LanguageContext)
  const Days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];


  const GetPatientProgramDetails = async () => {
    let req = new SearchStringOrIntReq();
    req.SearchInt = state.program.id;
    let res = await AppointmentsApi.GetPatientProgramById(req);
    if (res.status == "Success") {

      setResponseData(res);
    }
    else {
      Swal.fire({
        title: 'Error',
        text: res.message,
        icon: 'error',
        confirmButtonText: 'Ok'
      })
    }
  }

  const ApplyClick = async () => {
    let confirmation = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, apply it!'
    });
    if (!confirmation.isConfirmed) {
      return;
    }

    Swal.fire({
      title: 'Please wait',
      text: 'Applying program',
      // allowOutsideClick: false,
      // allowEscapeKey: false,
      // allowEnterKey: false,
      didOpen: () => {
        Swal.showLoading()
      }
    })

    let req = new SearchStringOrIntReq();
    req.SearchInt = state.program.id;
    req.SearchDate = searchDate;

    let res = await AppointmentsApi.ApplyPatientProgram(req);
    if (res.status == "Success") {
      Swal.fire({
        title: 'Success',
        text: res.message,
        icon: 'success',
        confirmButtonText: 'Ok'

      })
    }
    else {
      Swal.fire({
        title: 'Error',
        text: res.message,
        icon: 'error',
        confirmButtonText: 'Ok'
      })
    }
  }

  const RemovePatientAppointments = async () => {
    let confirmation = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, remove it!'
    });
    if (!confirmation.isConfirmed) {
      return;
    }

    Swal.fire({
      title: 'Please wait',
      text: 'Removing appointments',
      // allowOutsideClick: false,
      // allowEscapeKey: false,
      // allowEnterKey: false,
      didOpen: () => {
        Swal.showLoading()
      }
    })

    let req = new SearchStringOrIntReq();
    req.SearchInt = state.program.patientId;
    req.SearchDate = searchDate;

    let res = await AppointmentsApi.RemovePatientAppointments(req);
    if (res.status == "Success") {
      Swal.fire({
        title: 'Success',
        text: res.message,
        icon: 'success',
        confirmButtonText: 'Ok'
      })
    }
    else {
      Swal.fire({
        title: 'Error',
        text: res.message,
        icon: 'error',
        confirmButtonText: 'Ok'
      })
    }
  }



  useEffect(() => {
    if (!IsLoaded) {
      GetPatientProgramDetails();
    }
  }, [IsLoaded])



  useEffect(() => {
    //Check if data is loaded
    if (Object.keys(ResponseData).length > 0) {
      setIsLoaded(true);
    }
    else {
      setIsLoaded(false);
    }
  }, [ResponseData])

  const MakeTableRow = (dayIndex) => {
    let hours = ResponseData.data.days[dayIndex].hours;
    hours.sort((a, b) => (a.hourIndex > b.hourIndex ? 1 : -1));

    let count = 0; // Initialize counter outside the map function

    const tableRow = (
      <Grid container spacing={2}>
        {hours.map((entry, index) => {
          if (entry != null && entry.session != null) {
            count++; // Increment the counter when the condition is true

            return (
              <Grid item xs={6} sm={3}  key={index}>
  <MDTypography variant="h6" fontWeight="regular" color="text">
    {entry.session.name}
  </MDTypography>
  <MDTypography variant="body2" fontWeight="regular" color="text">
    {entry.therapist?.getUser.name}
  </MDTypography>
</Grid>

            );
          } else {
            return (
              <Grid item xs={6} sm={3} key={index}>
                <MDTypography variant="h6" fontWeight="regular" color="text">
                  {entry.hourIndex}:00
                </MDTypography>
              </Grid>
            );
          }
        })}
      </Grid>
    );

    return { tableRow, count }; // Return both tableRow and count
  };

  const MakeTable = () => {
    return Days.map((day, index) => {
      const { tableRow, count } = MakeTableRow(index); // Destructure the result

      return (
        <Accordion key={index}>
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <MDTypography variant="h6" fontWeight="bold">
              {day} {count > 0 ? `(${count} sessions)` : ''} {/* Display count if there are sessions */}
            </MDTypography>
          </AccordionSummary>
          <AccordionDetails>{tableRow}</AccordionDetails>
        </Accordion>
      );
    });
  };




  if (!IsLoaded) {
    return (
      <div>
        <MDBox>
          <MDTypography component="a" variant="button" color="text" fontWeight="medium">
            Loading Log Data...
          </MDTypography>
        </MDBox>
      </div>
    )
  }


  return (

    <DashboardLayout>
      <DashboardNavbar />
      <Card>
        <CardHeader title={translations.PatientProgramDetails} />
        <MDBox>
          <DateTimePicker className="data-picker-format" onChange={SetSearchDate} value={searchDate} />
          <MDButton variant="contained" color="success" size="large" sx={{
            margin: "1em", width: {
              xs: "90%",
              sm: "auto",
            },
          }}
            onClick={ApplyClick}>
            {translations.ApplyProgramToSchedule}
          </MDButton>
          <MDButton variant="contained" color="dark" size="large" sx={{
            margin: "1em", width: {
              xs: "90%",  
              sm: "auto",  
            },
          }}
            onClick={RemovePatientAppointments}>
            {translations.RemovePatientAppointments}
          </MDButton>
        </MDBox>
        <div className='accordion-container'>

          {MakeTable()}
        </div>

      </Card>
    </DashboardLayout>

  )
}

export default index